import styled from "styled-components";

export const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
  font-family: inherit;
`;

export const DropdownHeader = styled.input`
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  outline: none;
  transition: border 0.2s, box-shadow 0.2s;
  color: #333;
  width: 100%;
  cursor: pointer;

  &:focus {
    border-color: #1f8560ff;
    box-shadow: 0 0 0 2px rgba(21, 149, 96, 0.2);
  }
`;

export const DropdownListContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: 1000;
`;

export const DropdownList = styled.ul`
  margin: 0;
  margin-top: 1px;
  padding: 0;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  list-style: none;
  max-height: 180px;
  overflow-y: auto;

  /* Scrollbar customization */
  scrollbar-width: thin; 
  scrollbar-color: #0f6f64ff #ffffffff;

  /* Chrome, Edge, Safari */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #0f6f64ff;
    border-radius: 8px;
    border: 2px solid #ffffffff;
  }
`;


export const ListItem = styled.li`
  padding: 6px 12px;
  cursor: pointer;
  font-size: 12px;
  &:hover {
    background: #f2f2f2;
  }
`;
